import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const enginesOldPlugin = createPlugin({
  id: 'engines-old',
  routes: {
    root: rootRouteRef,
  },
});

export const EnginesOldPage = enginesOldPlugin.provide(
  createRoutableExtension({
    name: 'EnginesOldPage',
    component: () => import('./components/index').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
